import LinkProjectViewEditModal from "./link-project-view/link-project-view-edit"
import EmbedProjectViewEditModal from "./embed-project-view/embed-project-view-edit"
import ProjectView_Link from "../model2/project-view/views/link/link-view"
import ProjectView_Embed from "../model2/project-view/views/embed/embed-view"

export default class ProjectViewModalsManager {

    editLinkView = (view:ProjectView_Link) => {
        gd.modal.showV4({
            className   : 'modal-project-link-view-edit',
            component   : LinkProjectViewEditModal,
            params      : {
                view: view,
            }
        })
    }

    editEmbedView = (view:ProjectView_Embed) => {
        gd.modal.showV4({
            className   : 'modal-project-embed-view-edit',
            component   : EmbedProjectViewEditModal,
            params      : {
                view: view,
            }
        })
    }
}
